import { Typography } from '@material-ui/core'
import React from 'react'
import OrdersList from '../../component/Config/Orders/OrdersList'
import { useSubscriptionStyles } from '../../component/Config/Subscription/styles'
import SubscriptionLayout from '../../component/Config/Subscription/SubscriptionLayout'

export const Orders = (): JSX.Element => {
  const classes = useSubscriptionStyles()

  return (
    <SubscriptionLayout>
      <h1 className={classes.title}>Pedidos</h1>
      <h2 className={classes.description}>
        Lista de histórico e informações de orçamentos
      </h2>
      <br />
      <br />
      <Typography variant="caption">Histórico de Orçamentos</Typography>
      <OrdersList />
    </SubscriptionLayout>
  )
}
